import { createApp } from "vue";
import App from "./App.vue";
import router from "./common/router";
import store from "./common/store";

import "@/common/assets/css/index.scss";

createApp(App).use(store).use(router).mount("#app");
// const app = createApp(App);

// // 전역 믹스인 등록
// app.mixin(UtilMixin);

// // Vuex 스토어와 Vue Router 플러그인 등록
// app.use(store);
// app.use(router);

// // 애플리케이션을 HTML 요소에 마운트
// app.mount("#app");
